import { defineMessages } from '@redbubble/next/intl';

export const couponMessages = defineMessages({
  couponAvailable: {
    defaultMessage:
      'You have {count, plural, =1 {# coupon} other {# coupons}} available',
  },
  availableOffers: {
    defaultMessage: 'New! Click to see any available offers',
  },
  couponCode: {
    defaultMessage: 'Coupon code',
  },
  applyCouponButton: {
    defaultMessage: 'Apply',
  },
  removeCouponButton: {
    defaultMessage: 'Remove',
  },
  couponGiftCard: {
    defaultMessage: 'Coupon / Gift Card',
  },
  addCouponGiftCard: {
    defaultMessage: 'Add a Coupon / Gift Card',
  },
  enterCodeInputPlaceholder: {
    defaultMessage: 'Enter code',
  },
  showCouponInputButton: {
    defaultMessage: 'Enter a coupon or gift card',
  },
  couponCodeInputHiddenLabel: {
    defaultMessage: 'Coupon Code',
    description:
      'A visually hidden label for coupon code input for screen reader',
  },
  couponCodeInputPlaceHolder: {
    defaultMessage: 'Enter a coupon',
    description: 'Placeholder for the coupon code input',
  },
  applyCouponCodeFormSubmit: {
    defaultMessage: 'Apply coupon code',
    description:
      'string for coupon code apply button, visually hidden, used for screen reader',
  },
  couponApplyRateLimitError: {
    defaultMessage: `Whoa, you've tried to add a coupon too many times. Please try again later.`,
  },
  couponAppliedSuccessMessage: {
    defaultMessage: 'Coupon applied.',
  },
  couponMemberOffers: {
    defaultMessage: 'Member Offers',
  },
  percentageOffDisclaimer: {
    defaultMessage: `This coupon doesn’t apply to items already receiving a better discount.`,
  },
  learnMore: {
    defaultMessage: 'Learn more.',
  },
  expiresOnDate: {
    defaultMessage: 'Expires {expiresOn}',
  },
  expiresThisHour: {
    defaultMessage: 'Expires in less than 1 hour',
  },
  expiresInDaysOrHours: {
    defaultMessage: 'Expires {expiresIn}',
  },
  change: {
    defaultMessage: 'Change',
  },
  close: {
    defaultMessage: 'Close',
  },
  otherCoupons: {
    defaultMessage: 'Other coupons',
  },
  closeCoupons: {
    defaultMessage: 'Close coupons',
  },
});
